//core
import React from "react";

//styles
import cx from "classnames";
import styles from "./LifeCompareBarGraphLegend.module.scss";

interface IBarGraphLegend {
    data: { average: number; mostPopular: number }[];
    className?: string;
}

const BarGraphLegend: React.FC<IBarGraphLegend> = (props) => {
    const { data, className } = props;

    return (
        <div
            className={cx("layout-bar-graph-legend text-font-size-s text-semi-bold", {
                [className]: !!className
            })}>
            {data.map((item, index, array) => {
                return (
                    <div
                        key={index}
                        className={cx(
                            {
                                [styles["single-client"]]: array.length === 1
                            },
                            styles["tablet-portrait"]
                        )}>
                        {data.length > 1 && (
                            <div className="layout-flex-row--centered">
                                <div
                                    className={cx(
                                        "space-m",
                                        styles["legend-icon"],
                                        styles[`bar-color-${index + 1}`]
                                    )}
                                />
                                <span className="text-font-size-m">{`Adult ${
                                    index + 1
                                }`}</span>
                            </div>
                        )}
                        <div className="text-no-bold">{`Average ${
                            item.average
                                ? "$" + item.average.toLocaleString("en-NZ")
                                : "N/A"
                        }`}</div>
                        <div>{`Most popular ${
                            item.mostPopular
                                ? "$" + item.mostPopular.toLocaleString("en-NZ")
                                : "N/A"
                        }`}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default BarGraphLegend;
